
export function prepareErrorMessage (error = {}) {
    if(error?.message) return error?.message;
    if(error?.data?.message) return error?.data?.message;
    if(error?.data?.error?.message) return error?.data?.error?.message;
    return null;
}